import React, { FC } from 'react';

import { Stack, HStack, Box, Link } from '@chakra-ui/react';

import {
  CustomTooltip,
  DetailsIdentifier,
  EllipsisText,
  ExpandableText,
  renderSeverityBar,
  timeLabel,
} from 'components/DataDisplay';
import {
  renderCVEPackageName,
  renderCVEPatchStatus,
  renderCVSSScore,
} from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Vulnerability/CVE/utils';
import { limitedString } from 'utils/string';

interface Props {
  row: Record<string, any>;
  selectedTab?: string;
}

export const CVECommonFields: FC<Props> = props => {
  const { row, selectedTab = 'cve' } = props;

  return (
    <>
      <Stack spacing={5}>
        {selectedTab === 'cve' && (
          <HStack align="flex-start" spacing={10}>
            <Stack w="70%" spacing="7px">
              <Box overflow="hidden" minH={44}>
                <DetailsIdentifier
                  label={'Description'}
                  direction="column"
                  value={
                    <ExpandableText noOfLines={5}>
                      {row?.description}
                    </ExpandableText>
                  }
                  isInline={false}
                />
              </Box>
              <HStack>
                <Stack w="33%" spacing={3}>
                  <DetailsIdentifier
                    label="Package(s)"
                    value={renderCVEPackageName(row)}
                    isInline={false}
                  />
                  <DetailsIdentifier
                    label="Status"
                    isInline={false}
                    value={renderCVEPatchStatus(row)}
                  />
                </Stack>
                <Stack w="33%" spacing={3}>
                  <DetailsIdentifier
                    label="Version(s)"
                    value={
                      <EllipsisText>{row?.installed_version}</EllipsisText>
                    }
                    isInline={false}
                  />
                  <DetailsIdentifier
                    label="CVSS Score"
                    value={renderCVSSScore(row)}
                    isInline={false}
                  />
                </Stack>
                <Stack w="33%" spacing={3}>
                  <DetailsIdentifier
                    label="Patch Version(s)"
                    value={<EllipsisText label={row?.fixed_in_version} />}
                    isInline={false}
                  />
                  <DetailsIdentifier
                    label="Source"
                    value={
                      row?.data_source?.URL && (
                        <CustomTooltip label={row?.data_source?.Name}>
                          <Link href={row?.data_source?.URL} target="_blank">
                            <Box color="primary" cursor="pointer">
                              {limitedString(row?.data_source?.Name)}
                            </Box>
                          </Link>
                        </CustomTooltip>
                      )
                    }
                    isInline={false}
                  />
                </Stack>
              </HStack>
            </Stack>
            <Stack spacing={3}>
              <DetailsIdentifier
                label="Severity"
                value={renderSeverityBar({
                  value: row?.severity,
                })}
                isInline={false}
              />
              <DetailsIdentifier
                label="Published"
                value={timeLabel(row?.published_date)}
                isInline={false}
              />
              <DetailsIdentifier
                label="Updated"
                value={timeLabel(row?.last_modified_date)}
                isInline={false}
              />
              <DetailsIdentifier
                label="First Seen At"
                value={timeLabel(row?.first_seen_at)}
                isInline={false}
              />
            </Stack>
          </HStack>
        )}
      </Stack>
    </>
  );
};
